import { BehaviorSubject, Observable } from 'rxjs';
import { EModeValue } from './dynamics/enums/mode.enum';

export class SizerState {
  private static modeChangeState$: BehaviorSubject<EModeValue> =
    new BehaviorSubject<EModeValue>(null);

  static setModeChangeState(state: EModeValue): void {
    SizerState.modeChangeState$.next(state);
  }

  static getModeChangeState(): Observable<EModeValue> {
    return SizerState.modeChangeState$;
  }
}
